import React from 'react';

export function LoadingScreen() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      minHeight: '100dvh',
      background: '#F7F0EA',
      padding: '0 0 48px 0',
    }}>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg width="320" height="320" viewBox="0 0 460 460" xmlns="http://www.w3.org/2000/svg" style={{ overflow: 'visible' }}>
          <style>{`
            @keyframes momsGlow1 { 0%,100%{opacity:0.1;r:90px} 50%{opacity:0;r:160px} }
            @keyframes momsGlow2 { 0%,100%{opacity:0.06;r:90px} 50%{opacity:0;r:210px} }
            @keyframes momsBreathe { 0%,100%{opacity:0.8} 50%{opacity:1} }
            .moms-g1 { animation: momsGlow1 5.6s ease-in-out infinite; }
            .moms-g2 { animation: momsGlow2 5.6s ease-in-out infinite 0.9s; }
            .moms-logo { animation: momsBreathe 5.6s ease-in-out infinite; }
          `}</style>
          <circle className="moms-g2" cx="230" cy="230" r="90" fill="#6E2726" />
          <circle className="moms-g1" cx="230" cy="230" r="90" fill="#6E2726" />
          <g className="moms-logo">
            <text x="230" y="234" textAnchor="middle" dominantBaseline="central" fontFamily="Georgia, serif" fontSize="36" fontWeight="400" letterSpacing="8" fill="#6E2726">MOMS</text>
          </g>
        </svg>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
        <span style={{ fontFamily: 'Georgia, serif', fontSize: 13, color: '#B09088', letterSpacing: 2 }}>Загрузка</span>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <style>{`
            @keyframes momsDots { 0%,80%,100%{opacity:0.2} 40%{opacity:0.6} }
            .moms-dot1 { animation: momsDots 2.8s ease-in-out infinite 0s; }
            .moms-dot2 { animation: momsDots 2.8s ease-in-out infinite 0.5s; }
            .moms-dot3 { animation: momsDots 2.8s ease-in-out infinite 1s; }
          `}</style>
          <span className="moms-dot1" style={{ width: 5, height: 5, borderRadius: '50%', background: '#B09088', display: 'inline-block' }} />
          <span className="moms-dot2" style={{ width: 5, height: 5, borderRadius: '50%', background: '#B09088', display: 'inline-block' }} />
          <span className="moms-dot3" style={{ width: 5, height: 5, borderRadius: '50%', background: '#B09088', display: 'inline-block' }} />
        </div>
      </div>
    </div>
  );
}
